import React from "react";
import style from "./PlanC.module.css";
import check from "../../../Assets/check.png";
import Button from "@mui/material/Button";

export const Master = ({ title, text, cost, btn }) => {
  const Linedivider = () => {
    return <div className={style.divider}> </div>;
  };


  return (
    <div className={style.card}>
      <h3 className={style.title}>{title}</h3>
      <p className={style.text}>{text}</p>
      <p className={style.mensuales}>Incluye</p>
      <div className={style.AllChecks}>
        <Linedivider></Linedivider>
        <div className={style.checkCont}>
          <img
            src={check}
            alt=""
            className={style.check}
          />
          <p className={style.checkText}>
            Dirección Fiscal
          </p>
        </div>
        <Linedivider></Linedivider>
        <div className={style.checkCont}>
          <img
            src={check}
            alt=""
            className={style.check}
          />
          <p className={style.checkText}>
            Sala de Reuniones. 8hs mensuales.
          </p>
        </div>
        <Linedivider></Linedivider>
        <div className={style.checkCont}>
          <img
            src={check}
            alt=""
            className={style.check}
          />
          <p className={style.checkText}>
            {" "}
            Internet Fibra Óptica WiFi,
          </p>
          </div>
        <Linedivider></Linedivider>
        <div className={style.checkCont}>
          <img
            src={check}
            alt=""
            className={style.check}
          />
          <p className={style.checkText}>
            {" "}
            Recepción de Mensajería.
          </p>
          </div>
        <Linedivider></Linedivider>
        <div className={style.checkCont}>
          <img
            src={check}
            alt=""
            className={style.check}
          />
          <p className={style.checkText}>
            {" "}
            Recepción y reenvio de Mensajes.
          </p>
          </div>
        <Linedivider></Linedivider>
        <div className={style.checkCont}>
          <img
            src={check}
            alt=""
            className={style.check}
          />
          <p className={style.checkText}>
            {" "}
            Whatsapp y Correo Electrónico.
          </p>
          </div>
        <Linedivider></Linedivider>
        <div className={style.checkCont}>
          <img
            src={check}
            alt=""
            className={style.check}
          />
          <p className={style.checkText}>
            {" "}
            Agua pura y café.
          </p>
          </div>
        <Linedivider></Linedivider>
        <div className={style.checkCont}>
          <img
            src={check}
            alt=""
            className={style.check}
          />
          <p className={style.checkText}>
            {" "}
            Parqueo con Seguridad Privada.
          </p>
        </div>
        <Linedivider></Linedivider>
        <div className={style.checkCont}>
          <img
            src={check}
            alt=""
            className={style.check}
          />
          <p className={style.checkText}>
            {" "}
            Sala de Reuniones. 10hs mensuales.
          </p>
          </div>
        <Linedivider></Linedivider>
        <div className={style.checkCont}>
          <img
            src={check}
            alt=""
            className={style.check}
          />
          <p className={style.checkText}>
            Llave en mano.
          </p>
        </div>
        <Linedivider></Linedivider>
        
        <div className={style.checkCont}>
          <img
            src={check}
            alt=""
            className={style.check}
          />
          <p className={style.checkText}>
            {" "}
            Terraza Lounge.
          </p>
          </div>
        <Linedivider></Linedivider>
        <div className={style.checkCont}>
          <img
            src={check}
            alt=""
            className={style.check}
          />
          <p className={style.checkText}>
            {" "}
            Muebles, escritorios y sillas.
          </p>
          </div>
        <Linedivider></Linedivider>
      </div>{" "}

      <h3 className={style.cost}>{cost}</h3>

      <a href="#contacto" style={{textDecoration:"none"}}>
          <Button
            variant="contained"
            color="primary"
            className={btn ? style.btn2 : style.btn}
          >
            Adquirir plan
          </Button>
      </a>
    </div>
  );
};
